<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import {getContractItemTwentyPath, getContractItemCreatePath} from "../../services/NavigationService";

export default Vue.extend({
    computed: {
        ...mapState({
            form: state => state.contract.contractManagement.form
        })
    },
    methods: {
        ...mapActions({
            contractManagementFormAddElement: 'contract/contractManagementFormAddElement',
            contractManagementFormRemoveElement: 'contract/contractManagementFormRemoveElement',
            contractManagementFormSetIndex: 'contract/contractManagementFormSetIndex'
        }),
        getContractItemTwentyPath(subPart, id) {
            return getContractItemTwentyPath(subPart, id);
        },
        getContractItemCreatePath(subPart) {
            return getContractItemCreatePath(subPart);
        }
    }
});
</script>
<template>
    <div class="contract-management-edit-form-add">
        <div class="contract-management-edit-form-add__content">
            <div class="contract-management-edit-form-add__elements">
                <div v-for="(element, index) in form[form.part][form.subPart]" :key="index" class="contract-management-edit-form-add__element">
                    <span class="contract-management-edit-form-add__remove" @click="contractManagementFormRemoveElement(index)">
                        <i class="fa fa-trash"/>
                    </span>
                    <span :class="{'contract-management-edit-form-add__name--active': index === form.index}"
                          class="contract-management-edit-form-add__name"
                          @click="contractManagementFormSetIndex(index)"
                    >
                        <span v-if="element.name">{{ element.name }}</span>
                        <span v-if="!element.name">{{ $t('contractManagement.edit.form.noTitle') }}</span>
                        <span v-if="element.id">
                            <a :href="getContractItemTwentyPath(form.subPart, element.id)" target="_blank"> {{ $t('contractManagement.edit.form.link') }}</a>
                        </span>
                        <span v-if="!element.id && element.name">
                            <a :href="getContractItemCreatePath(form.subPart)" target="_blank"> {{ $t('contractManagement.edit.form.create') }}</a>
                        </span>
                    </span>
                </div>
            </div>
            <div class="contract-management-edit-form-add__control">
                <div class="contract-management-edit-form-add__add-btn" @click="contractManagementFormAddElement">
                    {{ $t('contractManagement.edit.form.add') }}
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementEditFormAdd/ContractManagementEditFormAdd.vue